/* eslint-disable max-len */
const categoryMain = '.ec-store .ec-grid';
const productMain = '.ec-store .product-details .product-details__sidebar';
const cartMain = '.ec-store .ec-cart';

const commonCartSelectors = [
  // Cart summary sidebar, Цена товара в Summary
  `${cartMain} .ec-cart__sidebar .ec-cart__products .ec-cart-item__wrap .ec-cart-item__price .ec-cart-item__price-inner`,
  // Cart summary sidebar, сумма товаров
  `${cartMain} .ec-cart__sidebar .ec-cart-summary__body .ec-cart-summary__row--items .ec-cart-summary__price`,
  // Cart summary sidebar, скидка по купону
  `${cartMain} .ec-cart__sidebar .ec-cart-summary__body .ec-cart-summary__row--discount-coupon .ec-cart-summary__price`,
  // Cart summary sidebar, доставка
  `${cartMain} .ec-cart__sidebar .ec-cart-summary__body .ec-cart-summary__row--shipping .ec-cart-summary__price`,
  // Cart summary sidebar, общая скидка (на сумму больше Х)
  `${cartMain} .ec-cart__sidebar .ec-cart-summary__body .ec-cart-summary__row--discount .ec-cart-summary__price`,
  // Cart summary sidebar, сбор
  `${cartMain} .ec-cart__sidebar .ec-cart-summary__body .ec-cart-summary__row--handling-fee .ec-cart-summary__price`,
  // Cart summary sidebar, налоги
  `${cartMain} .ec-cart__sidebar .ec-cart-summary__body .ec-cart-summary__row--taxes .ec-cart-summary__price`,
  // Cart summary sidebar, подарочный сертификат
  `${cartMain} .ec-cart__sidebar .ec-cart-summary__body .ec-cart-summary__row--gift-card .ec-cart-summary__price`,
  // Cart summary sidebar, чаевые
  `${cartMain} .ec-cart__sidebar .ec-cart-summary__body .ec-cart-summary__row--surcharge .ec-cart-summary__price`,
  // Cart summary sidebar, Total в Summary (слева)
  `${cartMain} .ec-cart__sidebar .ec-cart-summary__body .ec-cart-summary__row--total .ec-cart-summary__total`,
];

const anyPageSelectors = [
  // Сообщения о Minimum/Maximum allowed order subtotal
  '.ec-store .ec-notices .ec-notice .ec-currency-converter-element-subtotal',
  // You May Also Like слайдер
  '.ec-related-products__products .grid-product__price-value.ec-price-item',
];

const selectorsConfig = {
  CATEGORY: [
    // основная цена
    `${categoryMain} .grid-product__price-value`,
    // “Compare to” цена (SALE) - зачеркнутое значение
    `${categoryMain} .grid-product .grid-product__price .grid-product__price-compare strike`,
    // “Compare to” цена (SALE) - сумма скидки
    `${categoryMain} .grid-product .grid-product__price .grid-product__price-compare .grid-product__price-label .ec-currency-converter-element-save-price`,
  ],
  PRODUCT: [
    // основная цена:
    `${productMain} .product-details-module .product-details__product-price .details-product-price__value.ec-price-item`,
    // “Compare to” цена (SALE) - зачеркнутое значение
    `${productMain} .product-details-module .product-details__product-on-sale .details-product-price-compare__value`,
    // “Compare to” цена (SALE) - сумма скидки
    `${productMain} .product-details-module .product-details__product-on-sale .details-product-price-discount__value`,
    // “Price per unit”
    `${productMain} .product-details-module .product-details__price-per-unit-block .product-details__price-per-unit .ec-currency-converter-element-per-unit`,
    // Модификаторы цены в Опциях - RADIO/SIZE/CHECKBOX
    `${productMain} .details-product-options .product-details-module .option-surcharge__value`,
    // Модификаторы цены в Опциях - select
    `${productMain} .details-product-options .product-details-module .form-control__select option`,
    // Модификаторы цены в Опциях - input связанный с селектом
    `${productMain} .details-product-options .product-details-module .form-control__text`,
    // Таблица оптовых цен
    `${productMain} .product-details__product-price-wholesale .details-product__wholesale-price`,
    // Налоги (может быть несколько)
    `${productMain} .product-details-module .product-details__product-price-taxes .details-product-price-tax__value`,
  ],
  CART: [
    ...commonCartSelectors,

    // Cart discount sidebar, примененный купон; data-attrubute - data-discount
    `${cartMain} .ec-cart-discount-group .ec-cart-discount-group__coupon .ec-applied-coupon-message`,

    // Cart discount sidebar, примененный сертификат; data-attribute - data-balance
    `${cartMain} .ec-cart-discount-group .ec-cart-discount-group__giftcard .ec-applied-giftcard-message`,
  ],
  CHECKOUT_DELIVERY: [
    ...commonCartSelectors,

    // стоимость доставки при выборе способа доставки (справа)
    `${cartMain} .ec-cart__body .ec-radiogroup .ec-radiogroup__item-wrap .ec-radiogroup__data-title`,

    // подпись условно бесплатной доставки для заказов с определенной суммой
    `${cartMain} .ec-cart__body .ec-radiogroup .ec-radiogroup__item-wrap .ec-radiogroup__body .ec-unavailable-reason`,
  ],
  CHECKOUT_ADDRESS: [...commonCartSelectors],
  CHECKOUT_PAYMENT_DETAILS: [
    ...commonCartSelectors,

    // стоимость подтвержденной доставки в описании заказа сверху
    `${cartMain} .ec-cart__body .ec-cart__steps .ec-cart-step--delivery.ec-cart-step--done .ec-cart-step__text .ec-currency-converter-element-shipping-cost`,

    // Чаевые процентами
    `${cartMain} .ec-form--tips .form-control--checkbox-button .option-title`,

    // Перевод чаевых с процентами в абсолютное значение
    `${cartMain} .ec-form--tips .form-control--checkbox-button .form-control__inline-label .option-surcharge`,

    // Чаевые абсолютные
    `${cartMain} .ec-form--tips .form-control--checkbox-button .form-control__inline-label .option-title`,
  ],
  ORDER_CONFIRMATION: [
    // "Итого" в общей информации о заказе
    '.ec-store .ec-confirmation .ec-confirmation__body .ec-confirmation__section .ec-confirmation__order-confirmation-total',
  ],
};
/* eslint-enable max-len */

const getCurrencySelectArea = () => {
  return document.querySelector('.ec-currency-converter-selector');
};

const getCurrencySelect = () => {
  return document.querySelector(
    '.ec-currency-converter-selector .form-control__select'
  );
};

const getCurrencySelectText = () => {
  return document.querySelectorAll(
    '.ec-currency-converter-selector .form-control__select-text span'
  )[1];
};

const getOriginalSubtotal = () => {
  return document.querySelector('.ec-currency-converter-alt-value');
};

const getOriginalCurrencyNotes = () => {
  return document.querySelector('.ec-currency-converter-notes');
};

const getPriceElementsByPage = (pageType) => {
  const pageSelectors = selectorsConfig[pageType];
  const selectors = pageSelectors.concat(anyPageSelectors);
  return Array.from(document.querySelectorAll(selectors));
};

const getSelectors = () => {
  const selectors = Object.values(selectorsConfig)
    .flat()
    .concat(anyPageSelectors);

  return selectors;
};

export {
  getCurrencySelect,
  getCurrencySelectArea,
  getCurrencySelectText,
  getPriceElementsByPage,
  getSelectors,
  getOriginalSubtotal,
  getOriginalCurrencyNotes,
};
